import { apiRequest } from "@/services/api-client";

export interface SiegeMapClearEntry {
  map_key: string;
  best_stars: number;
}

export interface SiegeMapClearsResponse {
  clears: SiegeMapClearEntry[];
  /** @deprecated Prefer `clears`. */
  cleared_map_keys?: string[];
}

export const getSiegeMapClears = () =>
  apiRequest<SiegeMapClearsResponse>("/siege/map-clears");
